import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CalendarFilledIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Calendar Filled`} {...props}>
    <Path
      fill="currentColor"
      d="M2 5.5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2V6H2v-.5ZM2 7h12v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Z"
    />
    <Rect width={1.5} height={3} x={5} y={2} fill="currentColor" rx={0.75} />
    <Rect width={1.5} height={3} x={9.5} y={2} fill="currentColor" rx={0.75} />
  </Icon>
);
